<script>
export const group = 'Bottom'
</script>

<script setup>
import { computed } from 'vue'
import { cdnImageUrl } from '@dpgradio/creative'
import CharacterJumpFromTheRight from './text_animations/CharacterJumpFromTheRight.vue'
import CharacterEnlarge from './text_animations/CharacterEnlarge.vue'
import AnimatedSkewedEllipsMaskWithEnergeticFrequencies from './shared/AnimatedSkewedEllipsMaskWithEnergeticFrequencies.vue'
import TextSlideUp from './text_animations/TextSlideUp.vue'
import { frames } from '../../../utils/frames'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const timelineTitle = ref(null)
const timelineLineA = ref(null)
const timelineLineB = ref(null)
const timelineImage = ref(null)
const timelineLineChartTitle = ref(null)
const timelineLineChartPosition = ref(null)
const timelineLineChartPositionOut = ref(null)

const contentElement = ref(null)
const thumbnailElement = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'NowPlayingSmall' })
    .add(timelineTitle)
    .add(timelineImage, '<')
    .add(timelineLineA, '<.44')
    .add(timelineLineB, '<.24')
    .add(timelineLineChartTitle, '<.24')
    .add(timelineLineChartPosition, '<')
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  timelineTitle.value.reverse()
  timelineLineA.value.reverse()
  timelineLineB.value.reverse()
  timelineLineChartTitle.value?.reverse()

  return await gsapTimeline({ name: 'NowPlayingSmall - End' })
    .add(timelineLineChartTitle, '<')
    .add(timelineLineChartPositionOut.value?.(), '<')
    .add(timelineTitle, '<')
    .add(timelineLineB, '<.08')
    .add(timelineLineA, '<.24')
    .to(thumbnailElement, { scale: 0, duration: frames(5), ease: 'power2.in' }, '<')
    .endInvisible(contentElement, '>0.25')
})

const activeEdition = computed(() => props.item.enrichment.track.activeEditions?.[0])
</script>

<template>
  <div class="h-full w-full">
    <div ref="contentElement" class="absolute bottom-0 p-safe flex items-end space-x-1 w-full">
      <AnimatedSkewedEllipsMaskWithEnergeticFrequencies v-if="item.enrichment.track.thumbnail" ref="thumbnailElement" class="-mb-10" @timeline="timelineImage = $event">
        <img :src="cdnImageUrl(item.enrichment.track.thumbnail)" class="w-full h-full object-cover" />
      </AnimatedSkewedEllipsMaskWithEnergeticFrequencies>
      <div class="flex-1 -space-y-3">
        <CharacterJumpFromTheRight text="Nu" class="text-q-cr-red-primary" @timeline="timelineTitle = $event" />
        <CharacterEnlarge :text="item.enrichment.track.title" class="text-white font-cervo font-bold text-[85px] line-clamp-1" @timeline="timelineLineA = $event" />
        <CharacterEnlarge :text="item.enrichment.track.artist.name" class="text-white font-cervo text-[85px]" @timeline="timelineLineB = $event" />
      </div>
      <div v-if="activeEdition" class="text-right pl-8 pb-2">
        <TextSlideUp
          :text="`#${activeEdition.position}`"
          class="text-q-cr-red-primary font-cervo font-bold text-[50px] -mb-1"
          @timeline="timelineLineChartPosition = $event"
          @timelineOut="timelineLineChartPositionOut = $event"
        />
        <CharacterEnlarge :text="activeEdition.list.name" class="text-white font-cervo font-bold text-[50px]" @timeline="timelineLineChartTitle = $event" />
      </div>
    </div>
  </div>
</template>
